<template>
  <section class="evaluate">
    <div class="tabs">
      <p>
        <span>选择分类 :</span>
        <a
          href="javascript:;"
          :class="active==item.id?'active':''"
          v-for="(item,index) in cats"
          :key="index"
          @click="onCat(item.id)"
        >{{item.name}}</a>
      </p>
      <p>
        <span>选择品牌 :</span>
        <a
          href="javascript:;"
          :class="active"
          v-for="(item,index) in products.brands"
          :key="index"
          @click="onBrand(item.id)"
        >{{item.name}}</a>
      </p>
      <p><el-input v-model="keyword" placeholder="请输入机型查询" style="width:200px;margin-right:10px;" size="small"></el-input>  <el-button type="primary" size="small" @click="handleSearch">搜索</el-button></p>
    </div>
    <div class="content">
      <div class="item" v-for="(item,index) in products.products" :key="index">
        <a href="javascript:;" @click="setProduct(item)">
          <div
            class="image"
            :style="'background:url('+item.originalImg+') no-repeat;background-size:100%;'"
          ></div>
          <div class="info">
            <p>{{item.goodsName}}</p>
            <p>
              回收价 :
              <span>
                <em>¥</em>
                {{item.shopPrice}}
              </span>
            </p>
          </div>
        </a>
      </div>
    </div>
    <div class="pages" style="margin-top:10px">
      <el-pagination background layout="prev, pager, next" :total="products.total" @current-change="handleCurrentChange" :current-page="page"></el-pagination>
    </div>
  </section>
</template>

<script>
export default {
  props: ["dialogVisibleValue"],
  data() {
    return {
      cats: [
        { id: 1, name: "手机" },
        { id: 2, name: "平板" },
        { id: 19, name: "笔记本" },
        { id: 22, name: "台式机" },
        { id: 9, name: "相机" },
        { id: 13, name: "数码" }
      ],
      active: 1,
      catId: 1,
      brandId: 1,
      keyword: "",
      size: 15,
      page: 1,
      keyword:""
    };
  },
  computed: {
    products() {
      return this.$store.state.oldproduct.products;
    },
    product() {
      return this.$store.state.oldproduct.product;
    }
  },
  methods: {
    onCat(id) {
      this.active = id;
      this.brandId = 0;
      this.page =1;
      this.fetchProductList();
    },
    onBrand(id) {
      this.brandId = id;
      this.page =1;
      this.fetchProductList();
    },
    fetchProductList() {
      let params = {
        catId: this.active,
        brandId: this.brandId,
        keyword: this.keyword,
        size: this.size,
        page: this.page
      };
      this.$store
        .dispatch("oldproduct/fetchProductList", { params })
        .then(() => {
          //   console.log(this.$store.state.oldproduct);
        });
    },
    setProduct(item) {
      this.$emit("setProduct", item);
      this.fetchProductData(item);
    },
    fetchProductData(item) {
      let params = {
        id: item.goodsId
      };
      this.$store
        .dispatch("oldproduct/fetchProductData", { params })
        .then(() => {
          //   console.log(this.$store.state.oldproduct);
        });
    },
    handleCurrentChange(value) {
      this.page = value;
      this.fetchProductList();
    },
    handleSearch(){
      this.size=12;
      this.page=1;
      this.active = 0;
      this.brandId = 0;
      this.fetchProductList();
    }
  },
  mounted() {
    this.fetchProductList();
  }
};
</script>

<style scoped>
.evaluate {
}
.tabs {
  position: relative;
}
.tabs p {
  margin: 5px 0;
  line-height: 24px;
}
.tabs p:nth-child(3){
  position: absolute;
  bottom: 50px;
  right:25px;
}
.tabs p span {
  color: #666;
}
.tabs p a {
  color: #333;
  margin-left: 10px;
}
.tabs p a.active {
  color: #3a8ee6;
}
.tabs p a:hover {
  color: #3a8ee6;
}
.content {
  display: flex;
  flex-wrap: wrap;
}
.content .item {
  width: 200px;
  margin: 10px 30px 10px 0;
  box-shadow: #dfdfdf 0 0 5px;
  padding: 5px 10px;
}
.content .item a {
  display: flex;
}
.content .item .image {
  width: 50px;
  height: 50px;
  background-size: 100% !important;
}
.content .item .info {
  margin-left: 10px;
}
.content .item .info p:nth-child(1) {
  font-size: 14px;
  margin: 3px 0 10px 0;
  height: 20px;
  line-height: 20px;
  width: 100px;
  overflow: hidden;
}
.content .item .info p span {
  font-size: 14px;
  color: #f9415d;
}
.content .item .info p em {
  font-size: 12px;
  font-style: normal;
}
</style>
